import * as R from 'ramda'
import { put, takeLatest, select } from 'redux-saga/effects'
import { redirect } from 'redux-first-router'

import {
  getQuizPage,
  NEXT_PAGE,
  PREVIOUS_PAGE,
  NEXT_UNANSWERED,
  GMA_QUIZ,
  PERSONALITY_QUIZ,
  INTEREST_QUIZ,
  toPersonalityQuiz,
  toInterestQuiz,
  toGmaQuiz,
} from 'ducks/router'
import { getRespondent } from 'ducks/respondent'

function* pagingSaga() {
  yield takeLatest([NEXT_PAGE, PREVIOUS_PAGE, NEXT_UNANSWERED], changePage)
}

function* changePage(action) {
  const { type, page, uuid } = yield select(getQuizPage)
  const actionPayload = { uuid, page, reversed: action.type === PREVIOUS_PAGE }
  let length = 1
  let nextQuestion = R.identity
  let actionCreator: any = () => null
  const { gma, personality, interest, stats } = yield select(getRespondent)
  switch (type) {
    case GMA_QUIZ: {
      nextQuestion = getFirstUnansweredGMA(gma)
      length = stats.gma.totalQuestions
      actionCreator = toGmaQuiz
      break
    }
    case PERSONALITY_QUIZ: {
      nextQuestion = getFirstUnansweredPersonality(personality)
      length = stats.personality.totalQuestions
      actionCreator = toPersonalityQuiz
      break
    }
    case INTEREST_QUIZ: {
      nextQuestion = getFirstUnansweredInterest(interest)
      length =
        interest.questions?.length ||
        interest.instruments?.questions?.length ||
        stats.interest.totalQuestions ||
        1
      actionCreator = toInterestQuiz
      break
    }
    default:
      console.error(`unknown section ${type}`)
      return
  }
  const pagerMap = {
    [NEXT_PAGE]: R.add(1),
    [PREVIOUS_PAGE]: R.add(-1),
    [NEXT_UNANSWERED]: nextQuestion,
  }
  const nextPage = R.pipe(
    R.prop('type'),
    R.propOr(R.identity, R.__, pagerMap),
  )(action)

  actionPayload.page = wrapIndex(length)(nextPage(page))
  const routeAction = actionCreator(actionPayload)
  yield put(redirect(routeAction))
}

const wrapIndex = length => idx => R.mathMod(idx, length)

const rotate = R.curryN(2, (n, xs) => {
  const idx = n % xs.length
  return xs.slice(idx).concat(xs.slice(0, idx))
})

const getFirstUnansweredGMA =
  ({ answers }) =>
  page => {
    return R.pipe(
      R.values,
      rotate(page + 1),
      R.findIndex(R.isNil),
      R.add(page + 1),
    )(answers)
  }

export const getFirstUnansweredPersonality =
  ({ answers, questions }) =>
  page => {
    return R.pipe(
      rotate(page + 1),
      R.findIndex(({ instrument, key }) =>
        R.pathSatisfies(R.isNil, [instrument, key], answers),
      ),
      R.when(R.lte(0), R.add(page + 1)),
      R.flip(R.modulo)(R.length(questions)),
    )(questions)
  }

export const getFirstUnansweredInterest =
  ({ answers, questions }) =>
  page => {
    return R.pipe(
      rotate(page + 1),
      R.findIndex(({ key }) => R.pathSatisfies(R.isNil, [key], answers)),
      R.when(R.lte(0), R.add(page + 1)),
      R.flip(R.modulo)(R.length(questions)),
    )(questions)
  }

export default pagingSaga
